var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 144,
    fill: "#fe4d01",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.5 27v22.5h-99V27a4.5 4.5 0 0 1 4.5-4.5h90a4.5 4.5 0 0 1 4.5 4.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117 18h-13.5v-4.5A4.5 4.5 0 0 0 99 9a4.5 4.5 0 0 0-4.5 4.5V18h-45v-4.5A4.5 4.5 0 0 0 45 9a4.5 4.5 0 0 0-4.5 4.5V18H27a9 9 0 0 0-9 9v90a9 9 0 0 0 9 9h90a9 9 0 0 0 9-9V27a9 9 0 0 0-9-9zm-76.5 9v4.5A4.5 4.5 0 0 0 45 36a4.5 4.5 0 0 0 4.5-4.5V27h45v4.5A4.5 4.5 0 0 0 99 36a4.5 4.5 0 0 0 4.5-4.5V27H117v18H27V27h13.5zm76.5 90H27V54h90v63z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8c08d62a593907c172111396f50fbc1e.svg";
export { ForwardRef as ReactComponent };